<template>
  <v-card outlined elevation="3" style="margin-left: 10px; margin-right: 10px">
    <v-row no-gutters>
      <v-col cols="auto" class="d-flex justify-center align-center">
        <v-card max-width="120" flat>
          <v-list-item class="pr-0">
            <v-list-item-content>
              <span class="label-m pl-2">
                {{ $t("task.lblStatusFilter") }}</span
              >
              <v-switch
                v-model="statusFilter"
                dense
                hide-details
                class="pt-0 pl-2"
                @change="onFilterToggleChange"
              ></v-switch>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col v-for="item in filterItems" :key="item.tex" style="padding: 10px">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-card
              v-bind="attrs"
              v-on="on"
              class="mx-auto rounded-card"
              outlined
              @click="onFilterClick(item.color)"
              :color="
                taskFilter === item.color ? `${item.color} lighten-5` : ''
              "
              elevation="1"
            >
              <v-list-item two-line class="pl-0">
                <v-sheet
                  :color="item.color"
                  height="60"
                  width="60"
                  class="ma-3 d-flex justify-center"
                >
                  <v-icon size="28" color="white">{{ item.icon }}</v-icon>
                </v-sheet>
                <v-list-item-content>
                  <span class="label-m text-uppercase"> {{ item.text }}</span>
                  <span class="body-xl">{{ getStatusCount(item.color) }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
          <span>{{ item.toolTipText }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "TaskFilter",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    showMyTask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterColor: "",
      currentFilter: null,
    };
  },
  computed: {
    ...mapState({
      tasksList: (state) => state.task.tasksList,
      taskFilter: (state) => state.task.taskFilter,
    }),
    ...mapGetters({
      getAllTaskList: "task/getAllTaskList",
    }),
    statusFilter: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    filterItems() {
      return [
        {
          color: "success",
          text: this.$t("task.lblClosed"),
          taskNumber: 0,
          icon: "mdi-calendar-check",
          infoText: this.$t("task.lblInfoClosed"),
          toolTipText: this.$t("task.tipClosedTask"),
        },
        {
          color: "info",
          text: this.$t("task.lbl5Days"),
          taskNumber: 0,
          icon: "mdi-calendar-week",
          infoText: this.$t("task.lblSufficientTime"),
          toolTipText: this.$t("task.tipActivateTask"),
        },
        {
          color: "warning",
          text: this.$t("task.lblLess5Days"),
          taskNumber: 0,
          icon: "mdi-calendar-alert",
          infoText: this.$t("task.lblLessTime"),
          toolTipText: this.$t("task.tipActivateTask"),
        },
        {
          color: "error",
          text: this.$t("task.lblDelayed"),
          taskNumber: 0,
          icon: "mdi-calendar-remove",
          infoText: this.$t("task.lblDelayedTask"),
          toolTipText: this.$t("task.tipDelayedTask"),
        },
      ];
    },
  },
  watch: {
    // taskFilter(value) {
    //   if (value === "") {
    //     this.filterColor = "";
    //     this.currentFilter = null;
    //   }
    // },
  },
  methods: {
    ...mapActions({
      setTasksFilter: "task/setTasksFilter",
    }),
    getStatusCount,
    onFilterClick,
    onFilterToggleChange,
  },
};

function onFilterToggleChange(value) {
  this.$emit("statusFilter", value);
}

function onFilterClick(statusColor) {
  if (this.taskFilter === statusColor) {
    this.setTasksFilter("");
  } else {
    this.filterColor = this.currentFilter = statusColor;
    this.setTasksFilter(statusColor);
  }
}

function getStatusCount(statusColor) {
  if (this.showMyTask) {
    let userTaskList = this.getAllTaskList.filter((obj) =>
      obj.assignees.some((item) => item.email === this.$auth.user.email)
    );
    return userTaskList
      .filter((task) => task.statusColor === statusColor)
      .length.toString();
  } else {
    return this.getAllTaskList
      .filter((task) => task.statusColor === statusColor)
      .length.toString();
  }
}
</script>

<style scoped>
.rounded-card {
  border-radius: 15px;
}
</style>